import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

function load (page) {
  return () => import(`page/${page}`)
}

export default new Router({
  routes: [
    { path: '/', component: load('index') },
    { path: '/currencies', component: load('currencies') },
    { path: '/currencies/:label', component: load('currencies/_label'), props: true },
    { path: '/404', component: load('404') },
    { path: '*', redirect: '/404' }
  ]
})



// WEBPACK FOOTER //
// ./src/router.js